import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from '../../services/routing/navigator';
import { SiteLocationService } from 'src/app/services/site-location/site-location.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-rglogo',
  templateUrl: './rglogo.component.html',
  styleUrls: ['./rglogo.component.scss'],
  standalone: true
})

export class RglogoComponent implements OnInit {

  @Input() isClickable: boolean = true;
  @Input() environmentName?: string;

  public rgLink: string;
  public rgLogoSrc: string;

  constructor(
    public config: ConfigService,
    public eventsService: EventsService,
    public navigator: Navigator,
    public utils: UtilsService,
    public platform: Platform,
    public siteLocationService: SiteLocationService
  ) {
  }

  ngOnInit(): void {
    this.environmentName = this.environmentName || this.config.getState();
    const statesRgLogoMap = this.siteLocationService.statesRgLogoMap;
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.environmentName = this.config.getState();
        this.rgLogoSrc = this.utils.getCDNAsset(statesRgLogoMap[this.environmentName]);
      })
    });

    this.rgLogoSrc = this.utils.getCDNAsset(statesRgLogoMap[this.environmentName]);
  }

  onRGLogo() {
    if (this.isClickable == false) return;
    return this.navigator.navigateTo("PlayerProtectionComponent", '', { path: 'rglogo' });
  }

}
